import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export class CoreModal extends PureComponent {
	static propTypes = {
		className: PropTypes.string,
		showing: PropTypes.bool,
		closeable: PropTypes.bool,
		dialog: PropTypes.bool,
		closeComponent: PropTypes.func,
		onClose: PropTypes.func,
		children: PropTypes.node,
		wide: PropTypes.bool,
	};

	static defaultProps = {
		showing: false,
		closeable: true,
		dialog: false,
		closeComponent: (props) => <div {...props}>x</div>,
		onClose: () => {},
	};

	_renderCloseComponent() {
		if (!this.props.closeable) {
			return null;
		}

		return React.createElement(this.props.closeComponent, {
			onClick: this.props.onClose,
			className: 'modal-close',
		});
	}

	render() {
		if (!this.props.showing) {
			return null;
		}

		const modalContent = (
			<div className={classnames(this.props.className, 'ph-modal')}>
				{!this.props.dialog && (
					<button
						onClick={this.props.onClose}
						type="button"
						className="modal-mask"
					/>
				)}
				<div className="modal-outer">
					<div
						className={classnames('modal-content', {
							wide: this.props.wide,
						})}
					>
						{this._renderCloseComponent()}
						{this.props.children}
					</div>
				</div>
			</div>
		);

		// Use portal to render modal at the root level
		const modalRoot = document.getElementById('js-modal-content');
		if (modalRoot) {
			return ReactDOM.createPortal(modalContent, modalRoot);
		}

		// Fallback to regular rendering if portal target doesn't exist
		return modalContent;
	}
}

export default CoreModal;
